import {useQuery} from '@tanstack/react-query'
import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import CustomApi from './use-custom-api'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const useFluidConfigureDetails = () => {
    const {getTokenWhenReady} = useAccessToken()
    const customapi = new CustomApi()
    const api = useCommerceApi()
    const {site} = useMultiSite()
    const {proxy} = api.shopperExperience.clientConfig

    const fetchFluidConfigureDetails = async () => {
        const token = await getTokenWhenReady()
        const apiName = 'fluid-configure-details'
        const endpointPath = '/'
        const parameters = {}
        const response = await customapi.get(token, apiName, endpointPath, parameters, proxy)

        return response
    }

    return useQuery({
        queryKey: ['use-fluid-configure-details', site?.id],
        queryFn: () => fetchFluidConfigureDetails(),
        enabled: true
    })
}

export default useFluidConfigureDetails
